import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { FileStack, ChevronDown } from "lucide-react";
import { insApi, errMsg, sar } from "../../lib/insApi";

const ST = { open: ["تحت الاعتماد — بانتظار العروض", "bg-amber-50 text-amber-700"], accepted: ["عرض مقبول", "bg-sky-50 text-sky-700"],
  issued: ["صدرت الوثيقة", "bg-emerald-50 text-emerald-700"], cancelled: ["ملغى", "bg-slate-100 text-slate-500"] };
const QST = { submitted: "مقدَّم", accepted: "مقبول", issued: "صادر", rejected: "لم يُقبل", cancelled: "ملغى" };
const FILTERS = [["", "الكل"], ["open", "تحت الاعتماد"], ["accepted", "مقبولة"], ["issued", "صادرة"]];
const dt = (s) => (s ? new Date(s).toLocaleString("ar-SA-u-nu-latn", { timeZone: "Asia/Riyadh", day: "numeric", month: "short", hour: "2-digit", minute: "2-digit" }) : "");

const ReqRow = ({ r }) => {
  const [open, setOpen] = useState(false);
  const [lbl, cls] = ST[r.status] || [r.status, "bg-slate-100"];
  return (
    <div className="rounded-xl border border-slate-200 bg-white" data-testid={`pc-ins-req-${r.id}`}>
      <button type="button" onClick={() => setOpen((v) => !v)} className="flex w-full flex-wrap items-center gap-2 p-3 text-start text-sm">
        <b>{r.org_name || "—"}</b><span className="text-slate-500">{r.kind_label} · {r.count} شخص</span>
        {r.channel === "rabet" && <span className="rounded-full bg-[#123A5C]/10 px-2 py-0.5 text-[11px] text-[#123A5C]">تأمين ربط</span>}
        <span className={`rounded-full px-2 py-0.5 text-[11px] ${cls}`}>{lbl}</span>
        <span className="text-xs text-slate-400">{dt(r.created_at)}</span>
        <span className="ms-auto flex items-center gap-1 text-xs text-slate-600">{r.quotes.length} عرض<ChevronDown className={`h-3.5 w-3.5 transition-transform ${open ? "rotate-180" : ""}`} /></span>
      </button>
      {open && (
        <div className="space-y-1.5 border-t border-slate-100 p-3">
          {r.contact && <p className="text-xs text-slate-500">مقدّم الطلب: {r.contact.name} · <span dir="ltr">{r.contact.email}</span>{r.contact.phone ? ` · ${r.contact.phone}` : ""}</p>}
          {!r.quotes.length && <p className="text-xs text-slate-400">لم تصل عروض بعد</p>}
          {r.quotes.map((q) => (
            <div key={q.id} className="flex flex-wrap items-center gap-2 rounded-lg bg-slate-50 px-3 py-2 text-sm" data-testid={`pc-ins-quote-${q.id}`}>
              <b>{q.provider_name}</b><span dir="ltr" className="font-semibold text-emerald-700">{sar(q.price_total)}</span>
              <span className="text-xs text-slate-500">{sar(q.price_per_member)} / شخص</span>
              <span className="rounded-full bg-white px-2 py-0.5 text-[11px]">{QST[q.status] || q.status}</span>
              <span className="ms-auto text-xs text-slate-400">{dt(q.created_at)}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export const PcInsRequests = () => {
  const [status, setStatus] = useState("");
  const [items, setItems] = useState(null);
  const load = useCallback(() => insApi.adminRequests(status).then((r) => setItems(r.items)).catch((e) => toast.error(errMsg(e))), [status]);
  useEffect(() => { load(); }, [load]);
  return (
    <section className="space-y-3" data-testid="pc-ins-requests">
      <div className="flex flex-wrap items-center gap-2">
        <h3 className="flex items-center gap-1.5 font-heading text-lg font-bold"><FileStack className="h-5 w-5 text-emerald-700" /> طلبات وعروض الشركات</h3>
        <div className="ms-auto flex gap-1">{FILTERS.map(([k, l]) => (
          <button key={k} type="button" onClick={() => setStatus(k)} data-testid={`pc-ins-filter-${k || "all"}`}
            className={`rounded-full px-3 py-1 text-xs ${status === k ? "bg-slate-900 text-white" : "bg-white text-slate-600 hover:bg-slate-100"}`}>{l}</button>
        ))}</div>
      </div>
      {items === null ? <p className="text-sm text-slate-400">جارٍ التحميل…</p> : !items.length
        ? <p className="rounded-2xl bg-white p-6 text-center text-sm text-slate-400">لا توجد طلبات</p>
        : items.map((r) => <ReqRow key={r.id} r={r} />)}
    </section>
  );
};
